(() => {
  const key = Symbol.for('shiftlume.marquee.runtime');
  if (window[key]) { window[key].init(document); return; }

  const selector = '[data-sl-marquee]';
  const states = new Map();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function hiddenCopy(node) {
    const copy = node.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    copy.removeAttribute('data-marquee-base');
    copy.querySelectorAll('[id], [data-shopify-editor-block], [data-shopify-editor-block-id], [tabindex]').forEach((el) => {
      ['id', 'data-shopify-editor-block', 'data-shopify-editor-block-id', 'tabindex'].forEach((attr) => el.removeAttribute(attr));
    });
    copy.querySelectorAll('a').forEach((link) => {
      const text = document.createElement('span');
      text.className = link.className;
      text.dir = link.dir;
      text.textContent = link.textContent;
      link.replaceWith(text);
    });
    return copy;
  }

  function init(root = document) {
    const items = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) items.unshift(root);
    items.forEach((viewport) => {
      if (states.has(viewport)) return;
      const track = viewport.querySelector('[data-marquee-track]');
      const groups = track?.querySelectorAll('[data-marquee-group]');
      const base = groups?.[0]?.querySelector('[data-marquee-base]');
      if (!track || groups.length !== 2 || !base) return;
      const primary = groups[0], duplicate = groups[1];
      let frame = 0, count = 0;

      function rebuild() {
        if (!viewport.isConnected || motion.matches) return;
        const baseWidth = base.getBoundingClientRect().width;
        const viewportWidth = viewport.clientWidth;
        if (!Number.isFinite(baseWidth) || !Number.isFinite(viewportWidth) || baseWidth <= 0 || viewportWidth <= 0) return;
        const needed = Math.max(2, Math.ceil(viewportWidth / baseWidth) + 1);
        if (needed !== count) {
          primary.replaceChildren(base);
          for (let i = 1; i < needed; i++) primary.append(hiddenCopy(base));
          duplicate.replaceChildren(...[...primary.children].map(hiddenCopy));
          count = needed;
        }
        const width = primary.getBoundingClientRect().width;
        if (!Number.isFinite(width) || width <= 0) return;
        track.style.setProperty('--sl-marquee-offset', (-width).toFixed(3) + 'px');
        const setting = Number(viewport.dataset.speed) || 40;
        const speed = Math.max(20, Math.min(80, setting)) * (viewportWidth < 750 ? .85 : 1);
        track.style.setProperty('--sl-marquee-duration', (width / speed).toFixed(3) + 's');
      }

      function schedule() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(rebuild);
      }
      function setPaused(paused) {
        viewport.dataset.paused = String(paused);
        const help = viewport.querySelector('[data-marquee-help]');
        if (help) help.textContent = paused
          ? 'Announcements paused. Press Space to resume scrolling.'
          : 'Moving announcements. Hover to pause, or press Space to pause or resume.';
      }
      function onClick(event) {
        if (event.target.closest?.('a')) return;
        setPaused(viewport.dataset.paused !== 'true');
      }
      function onKey(event) {
        if (event.key === 'Escape') { setPaused(true); return; }
        if (event.target === viewport && (event.code === 'Space' || event.key === 'Enter')) {
          event.preventDefault();
          setPaused(viewport.dataset.paused !== 'true');
        }
      }

      viewport.addEventListener('click', onClick);
      viewport.addEventListener('keydown', onKey);
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
      observer?.observe(viewport);
      window.addEventListener('resize', schedule);
      motion.addEventListener('change', schedule);
      document.fonts?.ready.then(schedule);
      const cleanup = () => {
        cancelAnimationFrame(frame);
        observer?.disconnect();
        window.removeEventListener('resize', schedule);
        motion.removeEventListener('change', schedule);
        viewport.removeEventListener('click', onClick);
        viewport.removeEventListener('keydown', onKey);
      };
      states.set(viewport, { schedule, cleanup });
      schedule();
    });
  }

  function unload(root) {
    for (const [viewport, state] of states) {
      if (root === viewport || root.contains?.(viewport)) {
        state.cleanup();
        states.delete(viewport);
      }
    }
  }
  function selectBlock(event, paused) {
    const viewport = event.target.closest?.(selector) || event.target.querySelector?.(selector);
    if (viewport) viewport.dataset.editorPaused = String(paused);
  }
  window[key] = { init };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
  document.addEventListener('shopify:block:select', (event) => selectBlock(event, true));
  document.addEventListener('shopify:block:deselect', (event) => selectBlock(event, false));
  document.fonts?.addEventListener('loadingdone', () => states.forEach((state) => state.schedule()));
})();
